import { useState } from 'react';
import { ReactComponent as Lightning } from 'assets/icons/B2B/bolt.svg';
import Popover from '@mui/material/Popover';
import QuickActions from './QuickActions';
import EngagementScore from '../engagement-score/EngagementScore';
import FeatureGate from 'components/common/FeatureGate';
import { FEATURE } from 'constant/features';
import InitialDocuments from '../BACKOFFICEFLOW/CLIENTVIEW/components/ClientProfile/components/InitialDocuments/InitialDocuments';
import ClientFlowInitialDocuments from '../BACKOFFICEFLOW/CLIENTVIEW/components/ClientProfile/components/InitialDocuments/ClientFlowInitialDocuments';
import FooterButton from '../FooterButton';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useTranslation } from 'react-i18next';

type QuickActionsProps = {
    clientView: boolean;
    clientFlow: boolean;
};

const QuickActionsButtonForMobile = ({ clientView, clientFlow }: QuickActionsProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        if (open) {
            setAnchorEl(null);
        }
    };

    const { t } = useTranslation();

    return (
        <>
            <FooterButton
                color="purple"
                isActive={!!anchorEl}
                onClick={(event) => {
                    handleClick(event);
                }}
            >
                <Lightning style={{ transform: 'scale(1.6)', paddingRight: '5px' }} />
                {t('quickActions', { lng: language })}
            </FooterButton>
            {open && (
                <div
                    aria-hidden="true"
                    onClick={handleClose}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 9050,
                        background: 'rgba(15, 23, 42, 0.18)',
                        backdropFilter: 'blur(6px)',
                        WebkitBackdropFilter: 'blur(6px)',
                    }}
                />
            )}
            <Popover
                id={id}
                open={open}
                keepMounted
                anchorPosition={{ top: 0, left: 0 }}
                onClose={handleClose}
                marginThreshold={0}
                sx={{ zIndex: 9100 }}
                slotProps={{
                    paper: {
                        sx: {
                            backgroundColor: 'transparent',
                            top: 'auto !important',
                            bottom: '64px',
                            left: '0 !important',
                            right: 0,
                            width: '100%',
                            maxWidth: 'none',
                            maxHeight: 'calc(100vh - 88px)',
                            marginTop: 0,
                            overflowX: 'visible',
                            overflowY: 'auto',
                            transform: 'none !important',
                            boxShadow: 'none',
                        },
                    },
                }}
            >
                <span
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        minWidth: '100vw',
                        gap: '8px',
                    }}
                >
                    <QuickActions
                        handleMobileQuickActionsPopoverClose={handleClose}
                        clientView={clientView}
                        clientFlow={clientFlow}
                    />
                    {clientView && (
                        <FeatureGate feature={FEATURE.CLIENT_ENGAGEMENT}>
                            <EngagementScore />
                        </FeatureGate>
                    )}
                    {clientView && <InitialDocuments />}
                    {clientFlow && <ClientFlowInitialDocuments />}
                </span>
            </Popover>
        </>
    );
};

export default QuickActionsButtonForMobile;
